import { render, staticRenderFns } from "./SmartMatchConfigModal.vue?vue&type=template&id=1136770c&scoped=true"
import script from "./SmartMatchConfigModal.vue?vue&type=script&lang=ts"
export * from "./SmartMatchConfigModal.vue?vue&type=script&lang=ts"
import style0 from "./SmartMatchConfigModal.vue?vue&type=style&index=0&id=1136770c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136770c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1136770c')) {
      api.createRecord('1136770c', component.options)
    } else {
      api.reload('1136770c', component.options)
    }
    module.hot.accept("./SmartMatchConfigModal.vue?vue&type=template&id=1136770c&scoped=true", function () {
      api.rerender('1136770c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smartMatch/SmartMatchConfigModal.vue"
export default component.exports